<template>
    <section class="LeitorPdf">
        <header class="leitor-topbar">
            <button type="button" class="btn-ghost" @click="voltar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
                Voltar
            </button>

            <div class="leitor-titulo" :title="nmArquivo">{{ nmArquivo || 'Periódico' }}</div>

            <div class="leitor-acoes">
                <div class="paginador">
                    <button type="button" class="btn-icon" :disabled="pageAtualPdf <= 1" @click="paginaAnterior" title="Página anterior">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6" /></svg>
                    </button>
                    <input id="paginador"
                           name="paginador"
                           type="text"
                           v-model="pagina"
                           @keyup="paginador"
                           aria-label="Página atual" />
                    <span class="paginador-total">/ {{ page_count }}</span>
                    <button type="button" class="btn-icon" :disabled="pageAtualPdf >= page_count" @click="proximaPagina" title="Próxima página">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6" /></svg>
                    </button>
                </div>

                <button v-if="!isCortesia"
                        type="button"
                        class="btn-gold"
                        @click="abrirTermos">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3v12M7 11l5 5 5-5M5 21h14" /></svg>
                    Download
                </button>
            </div>
        </header>

        <div class="pdfreader" :class="{ fullScreen: telaCheiaAtiva }">
            <div class="pdfreader__inner">
                <div id="pdf-viewer"></div>
            </div>
        </div>

        <div class="modalLoading" v-if="loading">
            <i class="fas fa-circle-notch fa-spin fa-3x"></i>
        </div>

        <div class="botoesZoom">
            <button type="button" class="btn-zoom" @click="telaCheia" title="Tela cheia">
                <i class="fas fa-compress"></i>
            </button>
            <button type="button" class="btn-zoom" @click="aumentaZoom" title="Aumentar zoom">
                <i class="fas fa-search-plus"></i>
            </button>
            <button type="button" class="btn-zoom" @click="diminuirZoom" title="Diminuir zoom">
                <i class="fas fa-search-minus"></i>
            </button>
        </div>

        <div class="termos-overlay" v-if="downloadMenuOpen" @click.self="fecharTermos">
            <div class="termos-modal" role="dialog" aria-modal="true" aria-labelledby="termosTitulo">
                <div class="termos-modal__header">
                    <h2 id="termosTitulo">Termos de aceite</h2>
                    <button type="button" class="btn-icon" @click="fecharTermos" title="Fechar">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
                    </button>
                </div>

                <p class="termos-modal__texto">
                    Este material é somente para uso próprio. Não pode ser copiado, reproduzido, republicado, transmitido ou distribuído para fins comerciais.
                </p>

                <label class="termos-check">
                    <input id="concordoTermos" type="checkbox" v-model="concordoTermos">
                    <span class="termos-check__box" aria-hidden="true">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3.5 8.5 6.5 11.5 12.5 4.5" /></svg>
                    </span>
                    <span>Concordo com os termos de utilização.</span>
                </label>

                <div class="termos-modal__actions">
                    <button type="button" class="btn-ghost" @click="fecharTermos">Cancelar</button>
                    <button type="button" class="btn-gold" :disabled="!concordoTermos" @click="verificaDownload">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3v12M7 11l5 5 5-5M5 21h14" /></svg>
                        Baixar PDF
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    const PDFJS_VERSION = '3.11.174'
    const PDFJS_CDN = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}`
    let pdfJsLoadPromise = null

    function loadPdfJs() {
        if (window.pdfjsLib) {
            return Promise.resolve(window.pdfjsLib)
        }
        if (pdfJsLoadPromise) {
            return pdfJsLoadPromise
        }

        pdfJsLoadPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = `${PDFJS_CDN}/pdf.min.js`
            script.onload = () => {
                const lib = window.pdfjsLib
                if (!lib) {
                    reject(new Error('PDF.js não carregou'))
                    return
                }
                lib.GlobalWorkerOptions.workerSrc = `${PDFJS_CDN}/pdf.worker.min.js`
                resolve(lib)
            }
            script.onerror = () => reject(new Error('Falha ao carregar o PDF.js'))
            document.head.appendChild(script)
        })

        return pdfJsLoadPromise
    }

    function base64ToUint8Array(base64) {
        const binary = atob(base64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i)
        }
        return bytes
    }

    function mensagemErro(err, fallback) {
        const payload = err && err.response && err.response.data
        if (typeof payload === 'string' && payload) return payload
        if (payload && payload.msg) return payload.msg
        if (err && err.response && err.response.statusText) return err.response.statusText
        if (err && err.message) return err.message
        return fallback
    }

    export default {
        name: 'LeitorPdf',
        components: { },
        computed: {
            user() {
                return this.$store.state.user
            },
            isCortesia() {
                const flag = (this.user && this.user.usuario && this.user.usuario.flCortesia)
                    || (this.user && this.user.flCortesia)
                    || this.cortesia
                return flag === 'Sim'
            },
        },
        props: {
            idPeriodico: {
                type: [String, Number],
                required: true,
            },
        },
        data() {
            return {
                downloadMenuOpen: false,
                telaCheiaAtiva: false,
                cortesia: 'Sim',
                nmArquivo: '',
                pdfBase64: '',
                concordoTermos: false,
                posProxPagePdf: 0,
                posPageAnteriorPdf: 0,
                pageAtualPdf: 1,
                pdfjsLib: null,
                thePdf: null,
                scale: 2,

                loading: true,
                page_count: 1,
                pagina: null,
            }
        },
        methods: {
            voltar() {
                if (window.history.state && window.history.state.back) {
                    this.$router.go(-1);
                    return;
                }
                this.$router.push({ name: 'Periodicos' });
            },

            abrirTermos() {
                this.concordoTermos = false;
                this.downloadMenuOpen = true;
                document.body.style.overflow = 'hidden';
            },

            fecharTermos() {
                this.downloadMenuOpen = false;
                this.concordoTermos = false;
                document.body.style.overflow = '';
            },

            onKeydown(e) {
                if (e.key === 'Escape' && this.downloadMenuOpen) {
                    this.fecharTermos();
                }
            },

            loadCortesia() {
                const local = (this.user && this.user.usuario && this.user.usuario.flCortesia)
                    || (this.user && this.user.flCortesia)
                if (local) {
                    this.cortesia = local
                }

                axios.get(`${urlApi}/Auth/GetDadosUser`)
                    .then(resp => {
                        const dados = (resp.data && resp.data.data) || resp.data || {}
                        if (dados.flCortesia) {
                            this.cortesia = dados.flCortesia
                        }
                    })
                    .catch(() => { })
            },

            downloadObjectAsJson(exportObj, exportName) {
                var dataStr = "data:application/pdf;base64," + exportObj;
                var downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute("download", exportName);
                document.body.appendChild(downloadAnchorNode);
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            },

            verificaDownload() {
                if (this.concordoTermos) {
                    this.downloadPdf();
                    this.fecharTermos();
                } else {
                    avisoErro('Para baixar o arquivo é necessário aceitar os termos de utilização do mesmo!');
                }
            },

            downloadPdf() {
                if (!this.pdfBase64) {
                    avisoErro('Arquivo do periódico não encontrado.');
                    return;
                }

                const nomeArquivo = this.nmArquivo || 'arquivo'

                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_DWN_PDF_PERIO' }).catch(() => { })

                axios.post(`${urlApi}/LogSollicita/SalvarLogAceiteTermo`, {
                    p_idArquivo: this.idPeriodico,
                    p_tpArquivo: 'PERIO',
                    p_dsTermo: 'Concordo com os termos',
                })
                    .then(res => {
                        if (!res.data.success) return

                        const nome = res.data.msg || nomeArquivo
                        this.downloadObjectAsJson(this.pdfBase64, nome + '.pdf')
                    })
                    .catch(err => avisoErro(mensagemErro(err, 'Não foi possível registrar o aceite dos termos.')))
            },

            telaCheia() {
                this.telaCheiaAtiva = !this.telaCheiaAtiva;
            },

            aumentaZoom() {
                var tamanho = $('.pdfreader').width();
                $('.pdfreader').css('padding', '0 0.5rem');
                $('.pdfreader').css('width', `calc(${tamanho}px + 50px)`);
                if ($('.pdfreader').width() > window.innerWidth) {
                    $('body').css('overflow-x', 'scroll');
                }
            },

            diminuirZoom() {
                var tamanho = $('.pdfreader').width();
                $('.pdfreader').css('padding', '0 0.5rem');
                $('.pdfreader').css('width', `calc(${tamanho}px - 50px)`);
                if ($('.pdfreader').width() < window.innerWidth) {
                    $('body').css('overflow-x', 'hidden');
                }
            },

            setPagina(page) {
                if (page < 1 || page > this.page_count) return;
                this.pageAtualPdf = page;
                this.pagina = page;
                const prox = $(`#canvas-pdf-page-${this.pageAtualPdf + 1}`).attr('data-local');
                const ant = $(`#canvas-pdf-page-${this.pageAtualPdf - 1}`).attr('data-local');
                this.posProxPagePdf = prox ? parseInt(prox) : Number.POSITIVE_INFINITY;
                this.posPageAnteriorPdf = ant ? parseInt(ant) : 0;
            },

            goToPage(page) {
                const canvas = document.getElementById(`canvas-pdf-page-${page}`);
                if (!canvas) return;
                this.setPagina(page);
                const top = parseInt(canvas.getAttribute('data-local')) - 65;
                window.scrollTo(0, isNaN(top) ? 0 : top);
            },

            paginaAnterior() {
                if (this.pageAtualPdf > 1) {
                    this.goToPage(this.pageAtualPdf - 1);
                }
            },

            proximaPagina() {
                if (this.pageAtualPdf < this.page_count) {
                    this.goToPage(this.pageAtualPdf + 1);
                }
            },

            paginador(e) {
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13) {
                    const page = parseInt(this.pagina, 10);
                    if (!isNaN(page)) this.goToPage(page);
                }
            },

            onPdfScroll() {
                if (window.pageYOffset >= this.posProxPagePdf) {
                    this.setPagina(this.pageAtualPdf + 1);
                } else if (window.pageYOffset <= this.posPageAnteriorPdf) {
                    this.setPagina(this.pageAtualPdf - 1);
                }
            },

            async carregarPeriodico() {
                this.loading = true;
                this.pdfBase64 = '';
                this.nmArquivo = '';
                document.removeEventListener('scroll', this.onPdfScroll);

                if (!this.idPeriodico) {
                    this.loading = false
                    avisoErro('Periódico inválido.')
                    return
                }

                try {
                    await this.getArquivo()
                } catch (err) {
                    this.loading = false
                    avisoErro(mensagemErro(err, 'Não foi possível carregar o periódico.'))
                }
            },

            async getArquivo() {
                try {
                    const resp = await axios.get(`${urlApi}/Periodico/GetArquivo/${this.idPeriodico}`, {
                        timeout: 120000,
                    })
                    const base64 = resp.data && resp.data.data
                    if (!base64) {
                        throw new Error((resp.data && resp.data.msg) || 'Arquivo PDF vazio.')
                    }
                    this.nmArquivo = (resp.data && resp.data.msg) || this.nmArquivo
                    this.pdfBase64 = base64
                    await this.createPdfViewer(base64)
                    document.addEventListener('scroll', this.onPdfScroll)
                } catch (err) {
                    avisoErro(mensagemErro(err, 'Não foi possível carregar o PDF.'))
                } finally {
                    this.loading = false
                }
            },

            renderPage(pageNumber, canvas) {
                const $this = this;
                $this.thePdf.getPage(pageNumber).then(function (page) {
                    var viewport = page.getViewport({ scale: $this.scale });
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    page.render({ canvasContext: canvas.getContext('2d'), viewport: viewport });
                    $(canvas).attr('data-local', $(canvas).offset().top);
                    if (pageNumber == 2) {
                        $this.posProxPagePdf = parseInt($('#canvas-pdf-page-2').attr('data-local'));
                    }
                });
            },

            async createPdfViewer(base64) {
                if (!this.pdfjsLib) {
                    this.pdfjsLib = await loadPdfJs()
                }

                const viewer = document.getElementById('pdf-viewer');
                if (!viewer) {
                    throw new Error('Área de visualização não encontrada.')
                }
                viewer.innerHTML = '';

                const pdf = await this.pdfjsLib.getDocument({ data: base64ToUint8Array(base64) }).promise
                this.thePdf = pdf;
                this.page_count = pdf.numPages;
                this.pagina = 1;
                this.pageAtualPdf = 1;

                for (var page = 1; page <= pdf.numPages; page++) {
                    var canvas = document.createElement("canvas");
                    canvas.id = 'canvas-pdf-page-' + page;
                    canvas.className = 'pdf-page-canvas';
                    viewer.appendChild(canvas);
                    this.renderPage(page, canvas);
                }
            },
        },
        mounted: function () {
            document.addEventListener('keydown', this.onKeydown);

            if (this.idPeriodico) {
                axios.post(`${urlApi}/LogSollicita/LogPeriodico`, { 'idPeriodico': this.idPeriodico });
            }

            this.loadCortesia();
            this.carregarPeriodico();
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.onKeydown);
            document.removeEventListener('scroll', this.onPdfScroll);
            document.body.style.overflow = '';
        },
        watch: {
            idPeriodico() {
                document.removeEventListener('scroll', this.onPdfScroll);
                this.carregarPeriodico();
            },
        },
    };
</script>

<style lang="scss" scoped>
    $gold: #C8922A;
    $gold-light: #E8A83A;
    $dark: #1A1A2E;
    $dark-mid: #2a2a42;
    $muted: #7a7060;
    $border-gold: rgba(200, 146, 42, 0.3);
    $topbar-h: 56px;

    .LeitorPdf {
        min-height: 100vh;
        background: #3a3a48;
        font-family: 'DM Sans', sans-serif;
        color: #fff;
    }

    .leitor-topbar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: $topbar-h;
        background: $dark;
        border-bottom: 1px solid $border-gold;
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 0 20px;
        z-index: 20;

        &::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, $gold 40%, transparent);
        }
    }

    .leitor-titulo {
        flex: 1;
        min-width: 0;
        text-align: center;
        font-family: 'Playfair Display', serif;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .leitor-acoes {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
    }

    .btn-ghost {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        background: none;
        border: 1px solid rgba(255, 255, 255, 0.18);
        border-radius: 6px;
        padding: 7px 14px;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;

        svg {
            width: 12px;
            height: 12px;
        }

        &:hover {
            color: $gold-light;
            border-color: $border-gold;
            background: rgba(200, 146, 42, 0.08);
        }
    }

    .btn-gold {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: $gold;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
        transition: background 0.2s;

        svg {
            width: 14px;
            height: 14px;
        }

        &:hover:not(:disabled) {
            background: $gold-light;
        }

        &:disabled {
            opacity: 0.45;
            cursor: not-allowed;
        }
    }

    .btn-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.16);
        background: transparent;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
        padding: 0;
        transition: all 0.2s;

        svg {
            width: 14px;
            height: 14px;
        }

        &:hover:not(:disabled) {
            color: $gold-light;
            border-color: $border-gold;
            background: rgba(200, 146, 42, 0.08);
        }

        &:disabled {
            opacity: 0.35;
            cursor: default;
        }
    }

    .paginador {
        display: flex;
        align-items: center;
        gap: 6px;
        color: rgba(255, 255, 255, 0.7);
        font-size: 13px;
    }

    .paginador-total {
        min-width: 2.2em;
    }

    #paginador {
        width: 44px;
        height: 32px;
        text-align: center;
        background: $dark-mid;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.16);
        border-radius: 6px;
        outline: none;

        &:focus {
            border-color: $gold;
        }
    }

    .pdfreader {
        padding: calc(#{$topbar-h} + 20px) 8rem 4rem;
        width: 100%;
        min-height: 100vh;
        max-width: 99vw;
        margin: 0 auto;
        box-sizing: border-box;

        &.fullScreen {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            width: calc(100vw - 17px);
        }
    }

    .pdfreader__inner {
        display: flex;
        justify-content: center;
    }

    :deep(.pdf-page-canvas) {
        width: 100%;
        border: none;
        padding: 0;
        margin-bottom: 1rem;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
        background: #fff;
        display: block;
    }

    .botoesZoom {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 15;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .btn-zoom {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid $border-gold;
        background: $dark;
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: background 0.2s, color 0.2s;

        &:hover {
            background: $gold;
            color: #fff;
        }
    }

    .modalLoading {
        position: fixed;
        inset: 0;
        z-index: 40;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(26, 26, 46, 0.72);
        color: #fff;
    }

    .termos-overlay {
        position: fixed;
        inset: 0;
        z-index: 50;
        background: rgba(26, 26, 46, 0.72);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
    }

    .termos-modal {
        width: 100%;
        max-width: 420px;
        background: #fff;
        color: $dark;
        border-radius: 12px;
        border: 1px solid #DEDBD4;
        box-shadow: 0 20px 60px rgba(26, 26, 46, 0.24);
        padding: 24px;
    }

    .termos-modal__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 12px;

        h2 {
            font-family: 'Playfair Display', serif;
            font-size: 1.35rem;
            font-weight: 700;
            margin: 0;
            color: $dark;
        }

        .btn-icon {
            color: $muted;
            border-color: #DEDBD4;

            &:hover {
                color: $gold;
            }
        }
    }

    .termos-modal__texto {
        font-size: 0.9rem;
        line-height: 1.55;
        color: $muted;
        margin: 0 0 18px;
    }

    .termos-check {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        cursor: pointer;
        font-size: 0.88rem;
        font-weight: 500;
        color: $dark;
        margin-bottom: 22px;
        user-select: none;

        input {
            position: absolute;
            opacity: 0;
            pointer-events: none;
        }
    }

    .termos-check__box {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        margin-top: 1px;
        border: 1.5px solid #DEDBD4;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        color: transparent;
        transition: all 0.15s;

        svg {
            width: 12px;
            height: 12px;
        }
    }

    .termos-check input:checked + .termos-check__box {
        background: $gold;
        border-color: $gold;
        color: #fff;
    }

    .termos-check:hover .termos-check__box {
        border-color: $gold;
    }

    .termos-modal__actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;

        .btn-ghost {
            color: $muted;
            border-color: #DEDBD4;

            &:hover {
                color: $dark;
                background: #f5f2eb;
            }
        }
    }

    @media (max-width: 991.98px) {
        .pdfreader {
            padding: calc(#{$topbar-h} + 12px) 0.75rem 5rem;
        }

        .leitor-titulo {
            display: none;
        }
    }

    @media (max-width: 575.98px) {
        .leitor-topbar {
            padding: 0 10px;
            gap: 8px;
        }

        .btn-ghost span,
        .btn-gold {
            font-size: 10px;
        }
    }
</style>

